import { Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from '../../auth/AuthProvider';
import { DashboardLayout, LoadingState } from '../../components/Layout';
import { SidebarStorefront, ShopTopBar } from '../../components/SidebarStorefront';
import { ShopProvider, useShop } from '../../context/ShopContext';
import CreateShopPage from './CreateShopPage';

const BASE_NAV_ITEMS = [
  { to: '/shop', label: 'Overview', end: true },
  { to: '/shop/products', label: 'Products' },
  { to: '/shop/collections', label: 'Collections' },
  { to: '/shop/categories', label: 'Categories' },
  { to: '/shop/orders', label: 'Orders' },
  { to: '/shop/customers', label: 'Customers' },
  { to: '/shop/inventory', label: 'Inventory' },
  { to: '/shop/billing', label: 'Billing' },
  { to: '/shop/currency', label: 'Currency' },
  { to: '/shop/members', label: 'Team' },
];

const DOMAIN_ROLES = new Set(['admin', 'manager']);

function ShopShell() {
  const { selectedShop, loading, shops, isPlatformUser } = useShop();

  if (loading) {
    return <LoadingState />;
  }

  if (isPlatformUser) {
    return <Navigate to="/platform" replace />;
  }

  if (shops.length === 0) {
    return <CreateShopPage />;
  }

  const navItems =
    selectedShop && DOMAIN_ROLES.has(selectedShop.role)
      ? [...BASE_NAV_ITEMS, { to: '/shop/settings', label: 'Settings' }]
      : BASE_NAV_ITEMS;

  return (
    <DashboardLayout title="Store admin" navItems={navItems} sidebarStorefront={<SidebarStorefront />}>
      <ShopTopBar />
      <Outlet />
    </DashboardLayout>
  );
}

export default function ShopLayout() {
  return (
    <AuthProvider mode="tenant">
      <ShopProvider>
        <ShopShell />
      </ShopProvider>
    </AuthProvider>
  );
}
